import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="February 2026" testid="terms-page">
      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">Welcome</h2>
        <p>
          Lyric Lock is a practice tool for singers who want to memorize song lyrics with less
          stress. By creating an account or using the service, you agree to these terms. If any
          part of them doesn't sit right, please don't use the service.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">Your account</h2>
        <p>
          You need an email address and a password to use Lyric Lock. Keep your password to
          yourself — anything done through your account is your responsibility. You must be at
          least 13 years old to create an account.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">Your content</h2>
        <p>
          You keep ownership of the songs, lyrics, backing tracks, and mic recordings you add.
          By uploading content you confirm that you have the right to do so — please only upload
          material that you own, that you have permission to use, or that is lawfully in the
          public domain. We store your content so we can show it back to you and power the
          practice features.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">Acceptable use</h2>
        <p>Please don't use Lyric Lock to:</p>
        <ul className="list-disc pl-6 mt-3 space-y-1">
          <li>Upload material you don't have the right to use.</li>
          <li>Attempt to break, probe, or overload the service.</li>
          <li>Scrape, resell, or redistribute the app or its content.</li>
          <li>Harass anyone or upload content that's illegal where you live.</li>
        </ul>
      </section>

      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">Third-party services</h2>
        <p>
          The app leans on a few external services to work — a public lyrics library
          (LRCLIB) for search, and AI providers (Google Gemini, OpenAI Whisper) for hints,
          analysis, and voice transcription. When you use those features, small pieces of your
          content are sent to those providers so they can do their part. Their own terms apply
          to that use.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">Service availability</h2>
        <p>
          We try to keep Lyric Lock running smoothly, but we can't promise it'll be up every
          minute or free of bugs. Features may change or go away. We may suspend or end accounts
          that break these terms or put the service at risk.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">No warranty</h2>
        <p>
          Lyric Lock is provided as-is. We do our best, but we can't guarantee it will meet
          every need or that it will always be error-free. To the fullest extent allowed by law,
          we are not liable for indirect or consequential damages that come from using the
          service.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">Changes to these terms</h2>
        <p>
          We may update these terms as the app grows. Big changes will be highlighted in the app
          before they take effect. Using the service after an update means you agree to the new
          terms.
        </p>
      </section>

      <section>
        <h2 className="font-display text-2xl md:text-3xl mb-3">Contact</h2>
        <p>
          Questions, feedback, or a legal notice? Reach us through the contact channel listed on
          the app's home page.
        </p>
      </section>
    </LegalLayout>
  );
}
